import React from "react";

const PartnerKpiCard = ({ label, value, sub, icon: Icon, accent }) => (
  <div className="rounded-2xl border border-partner bg-[#11151F] p-5 sm:p-6">
    <div className="flex items-start justify-between gap-3 mb-3">
      <p className="text-xs font-mono tracking-wider text-partner-muted uppercase">{label}</p>
      {Icon && (
        <Icon className={`w-5 h-5 flex-shrink-0 ${accent || "text-partner-accent"}`} />
      )}
    </div>
    <p className="text-2xl sm:text-3xl font-bold text-partner">{value}</p>
    {sub && <p className="text-sm text-partner-muted font-body mt-1">{sub}</p>}
  </div>
);

export default PartnerKpiCard;
